export default [
    {
        value: "CustoPrevistoDivulgacaoPublicacaoResultados",
        text: "Custo previsto de divulgação de resultados"
    },
    {
        value: "InscricaoEmCurso",
        text: "Inscrição em curso"
    },
    {
        value: "MensalidadeEmCurso",
        text: "Mensalidade em curso"
    },
    {
        value: "InscricaoEmEventos",
        text: "Inscrição em eventos"
    },
    {
        value: "INPI",
        text: "INPI"
    },
    {
        value: "Outros",
        text: "Outros"
    }
]